import './ZeroTrust.css'
import { useEffect, useReducer, useRef, useState } from 'react';
import { GetZeroTrustFilesAll, NIST, ZT } from './ZeroTrustData';
import ZeroTrustReducer, { emptyZTReducer } from './ZeroTrustReducer';
import { ImportProjectDialog } from '../ImportProject/ImportProject';
import ZTPhaseComponent from './ZTPhaseComponent';
import ZeroTrustContent from './ZeroTrustContent';
import ZeroTrustSidebar from './ZeroTrustSidebar';
import ZeroTrustDialogPopup from './ZeroTrustDialogPopup';


export const pillars:any = [
    {'id' : '1', 'name' : 'User', 'color': '#E8F5D5'},
    {'id' : '2', 'name' : 'Device', 'color': '#D2E9F8'},
    {'id' : '3', 'name' : 'Application & Workload', 'color': '#F8ECB4'},
    {'id' : '4', 'name' : 'Data', 'color': '#D0CECE'},
    {'id' : '5', 'name' : 'Network & Environment', 'color': '#FBD7AF'},
    {'id' : '6', 'name' : 'Automation & Orchestration', 'color': '#CCD6EA'},
    {'id' : '7', 'name' : 'Visibility & Analytics', 'color': '#E1D4FD'},
]

const _phases = [0,1,2,3,4];

export default function ZeroTrust(props:any){
    const [loading, setLoading] = useState(true);
    const [ztA, ztDispatch] = useReducer(ZeroTrustReducer, emptyZTReducer);
    console.log(ZT);

    useEffect(() => {
        GetZeroTrustFilesAll().then(() => {
            ztDispatch({type: 'init', payload: {
                phases : _phases,
                pillars : Object.keys(ZT.pillars),
            }});
            setLoading(false);
        });
    }, []);

    if(loading) return <>Loading...</>

    return(
        <div className="container-zero-trust">
            <ZeroTrustSidebar dispatch={ztDispatch} />
            <ZeroTrustContent actions={ztA} dispatch={ztDispatch}/>
            <ImportProjectDialog visible={ztA.showImport} dispatch={ztDispatch}/>
            <ZTPhaseComponent actions={ztA} dispatch={ztDispatch}/>
            <ZeroTrustDialogPopup ztA={ztA} ztDispatch={ztDispatch} />
        </div>
        
    )
}